import type { MegaMenuDesignTokens, MegaMenuTokenSections } from '@openng/optimus-ui-themes/types/megamenu';

export const mobileButton: MegaMenuTokenSections.MobileButton = {
	borderRadius: '{megamenu.mobile.button.size} / 2',
};

export default {
	mobileButton,
} satisfies MegaMenuDesignTokens;
